import BaseRepository from 'src/api/repositories/base.repository';
import config from 'src/config';

export default class CommonRepository extends BaseRepository {
  protected static readonly baseURL: string = config.api.commonBaseUrl;
}
